import { useState } from "react";
import { PageHero, Reveal, SectionHead, EmptyState } from "@/components/Shared";
import ProjectCard from "@/components/ProjectCard";
import { useCollection, IMG } from "@/lib/api";

const CATEGORIES = [
  "All",
  "Community Service",
  "Club Service",
  "International Service",
  "Partners-in-Service",
  "Entrepreneurship & Professional Development",
  "Sports",
  "Public Relations & Marketing",
  "Publications",
  "Digital Media",
  "Zonal Coordinator",
];

export default function Projects() {
  const { items, loading } = useCollection("projects");
  const [filter, setFilter] = useState("All");

  const filtered = (items || []).filter((p) => filter === "All" || p.category === filter);

  return (
    <main>
      <PageHero eyebrow="Projects" title="Work that" italic="outlives the moment" image={IMG.forestMist}>
        <p className="text-sm leading-relaxed text-silver-dim sm:text-base">
          Every RCSCW project is a story of planning, people and impact. Browse by avenue to discover what the club
          has built.
        </p>
      </PageHero>

      <section className="mx-auto max-w-7xl px-6 py-20" data-testid="projects-section">
        <Reveal>
          <div className="flex flex-wrap gap-3" data-testid="project-filters">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`border px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] transition-all duration-300 ${
                  filter === c
                    ? "border-ember bg-ember/10 text-ember"
                    : "border-silver/20 text-silver-muted hover:border-silver/50 hover:text-silver"
                }`}
                data-testid={`project-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {c}
              </button>
            ))}
          </div>
        </Reveal>

        {loading && <p className="mt-12 text-sm text-silver-muted">Loading projects…</p>}

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08} className="h-full">
              <ProjectCard p={p} index={i} />
            </Reveal>
          ))}
        </div>

        {!loading && filtered.length === 0 && (
          <div className="mt-12">
            <EmptyState title="No projects in this avenue yet" note="Projects added through the Admin panel will appear here instantly." />
          </div>
        )}
      </section>
    </main>
  );
}
